export default __webpack_public_path__ + "static/media/FuturaStdHeavy.dad8cb48.otf";